/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Progate_Upgrade1Inputs */

const zh_progate_upgrade1 = /** @type {(inputs: Progate_Upgrade1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`升级到 Pro`)
};

const en_progate_upgrade1 = /** @type {(inputs: Progate_Upgrade1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upgrade to Pro`)
};

const es_progate_upgrade1 = /** @type {(inputs: Progate_Upgrade1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualizar a Pro`)
};

/**
* | output |
* | --- |
* | "Upgrade to Pro" |
*
* @param {Progate_Upgrade1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const progate_upgrade1 = /** @type {((inputs?: Progate_Upgrade1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progate_Upgrade1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_progate_upgrade1(inputs)
	if (locale === "en") return en_progate_upgrade1(inputs)
	return es_progate_upgrade1(inputs)
});
export { progate_upgrade1 as "proGate_upgrade" }